module.exports = __webpack_public_path__ + "6865d3d9cd63128f3642b714c1475a39.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-11.png
// module id = 1557
// module chunks = 0